import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Transition as _Transition, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"
import _imports_0 from './assets/logo-only.svg'


const _hoisted_1 = {
  key: 0,
  class: "loader"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Treebal is loading"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_navbar = _resolveComponent("navbar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_toasts_container = _resolveComponent("toasts-container")!
  const _component_infobar = _resolveComponent("infobar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["app", {
      appLoading: _ctx.isLoading,
      appLoaded: !_ctx.isLoading,
      infobarmarge: _ctx.userOrganization.lockedDate,
    }])
    }, [
      (!_ctx.isFullPage && _ctx.isAuthenticated && !_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_navbar, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.isAuthenticated && !_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_router_view, { key: 1 }, {
            default: _withCtx(({ Component, route }) => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                key: route.path
              }))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isAuthenticated && !_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_toasts_container, {
            key: 2,
            class: "end-0 p-3"
          }))
        : _createCommentVNode("", true),
      (_ctx.isAuthenticated && !_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_router_view, {
            key: 3,
            name: "modals",
            class: "modals-container"
          }))
        : _createCommentVNode("", true),
      _createVNode(_Transition, { name: "loader" }, {
        default: _withCtx(() => [
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ], 2),
    _createVNode(_component_infobar),
    _createElementVNode("div", null, _toDisplayString(_ctx.appVersion), 1)
  ], 64))
}